import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductPipe } from './pipes/product.pipe';
import { ProductManagementComponent } from './components/main/product-management/product-management.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductFilterPipe } from './pipes/product-filter.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ProductFormComponent } from './components/embedded/product-form/product-form.component';
import { SelectProductTypeComponent } from './components/select/select-product-type/select-product-type.component';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from '../shared/shared.module';
import { ProductPicturesComponent } from './components/embedded/product-pictures/product-pictures.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';



@NgModule({
  declarations: [
    ProductPipe,
    ProductManagementComponent,
    ProductFilterPipe,
    ProductFormComponent,
    SelectProductTypeComponent,
    ProductPicturesComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [
    ProductPipe
  ]
})
export class ProductModule { }
